import Vue from 'vue'
import HomeIcon from 'vue-material-design-icons/Home.vue'
import NewspaperVariantOutlineIcon from 'vue-material-design-icons/NewspaperVariantOutline.vue'
import CellphoneBasicIcon from 'vue-material-design-icons/CellphoneBasic.vue'
import TrashCanOutlineIcon from 'vue-material-design-icons/TrashCanOutline.vue'
import AccountMultiplePlusOutlineIcon from 'vue-material-design-icons/AccountMultiplePlusOutline.vue'
import CreditCardOutlineIcon from 'vue-material-design-icons/CreditCardOutline.vue'
import HandClapIcon from 'vue-material-design-icons/HandClap.vue'
import PartyPopperIcon from 'vue-material-design-icons/PartyPopper.vue'
import AlertCircleOutlineIcon from 'vue-material-design-icons/AlertCircleOutline.vue'
import AccountCheckOutlineIcon from 'vue-material-design-icons/AccountCheckOutline.vue'

Vue.component('HomeIcon', HomeIcon)
Vue.component('NewspaperVariantOutlineIcon', NewspaperVariantOutlineIcon)
Vue.component('CellphoneBasicIcon', CellphoneBasicIcon)
Vue.component('TrashCanOutlineIcon', TrashCanOutlineIcon)
Vue.component('AccountMultiplePlusOutlineIcon', AccountMultiplePlusOutlineIcon)
Vue.component('CreditCardOutlineIcon', CreditCardOutlineIcon)
Vue.component('HandClapIcon', HandClapIcon)
Vue.component('PartyPopperIcon', PartyPopperIcon)
Vue.component('AlertCircleOutlineIcon', AlertCircleOutlineIcon)
Vue.component('AccountCheckOutlineIcon', AccountCheckOutlineIcon)
